export const commentStatus = [
  { id: 1, name: "Open" },
  { id: 2, name: "Approved" },
  { id: 3, name: "Rejected" },
];
